import React, { useState } from 'react'
import { Radio } from '@roo/roo'
import { useTranslation } from '@sailor/i18n-web'
import { FEExpenseCodeConfig, ExpenseCodeFillMode } from '../utils/types'

interface ExpenseCodeFormItemsProps {
  value?: FEExpenseCodeConfig;
  onChange?: (val: FEExpenseCodeConfig) => void;
}

const ExpenseCodeFormItems: React.FC<ExpenseCodeFormItemsProps> = ({ value, onChange }) => {
  const { t } = useTranslation()

  const enabled = value?.enabled ?? false
  const mode = value?.mode ?? 'NONE'
  const remarkMode = value?.remarkMode ?? 'NONE'

  const getDefaultMode = (current: ExpenseCodeFillMode): ExpenseCodeFillMode =>
    current === 'NONE' ? 'OPTIONAL' : current

  const handleEnabledChange = (nextEnabled: boolean) => {
    onChange?.({
      enabled: nextEnabled,
      mode: nextEnabled ? getDefaultMode(mode) : 'NONE',
      remarkMode: nextEnabled ? getDefaultMode(remarkMode) : 'NONE',
    })
  }

  const handleModeChange = (nextMode: ExpenseCodeFillMode) => {
    onChange?.({ enabled, mode: nextMode, remarkMode })
  }

  const handleRemarkModeChange = (nextRemarkMode: ExpenseCodeFillMode) => {
    onChange?.({ enabled, mode, remarkMode: nextRemarkMode })
  }

  return (
    <div>
      <Radio.Group
        value={enabled ? 'require' : 'none'}
        onChange={(val: string) => handleEnabledChange(val === 'require')}
      >
        <Radio value="none">{t('e_pc_order_no_fill', '下单无需填写')}</Radio>
        <Radio value="require">{t('e_pc_order_need_fill', '下单需填写')}</Radio>
      </Radio.Group>
      {enabled && (
        <div style={{ marginTop: 12, paddingLeft: 24, display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ minWidth: 120, fontSize: 14, color: '#1a1a1a' }}>
              {t('e_pc_expense_code_label', '费用代码')}
            </span>
            <Radio.Group
              value={mode === 'NONE' ? 'OPTIONAL' : mode}
              onChange={(val: ExpenseCodeFillMode) => handleModeChange(val)}
            >
              <Radio value="OPTIONAL">{t('e_pc_optional', '选填')}</Radio>
              <Radio value="REQUIRED">{t('e_pc_required', '必填')}</Radio>
            </Radio.Group>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ minWidth: 120, fontSize: 14, color: '#1a1a1a' }}>
              {t('e_pc_expense_remark', '费用备注')}
            </span>
            <Radio.Group
              value={remarkMode === 'NONE' ? 'OPTIONAL' : remarkMode}
              onChange={(val: ExpenseCodeFillMode) => handleRemarkModeChange(val)}
            >
              <Radio value="OPTIONAL">{t('e_pc_optional', '选填')}</Radio>
              <Radio value="REQUIRED">{t('e_pc_required', '必填')}</Radio>
            </Radio.Group>
          </div>
        </div>
      )}
    </div>
  )
}

export default ExpenseCodeFormItems
